import GruposCompra from '@/modules/compra-conjunta/grupos-compra/GruposCompra.vue';
import GrupoCompraCotacoes from '@/modules/compra-conjunta/cotacoes/GrupoCompraCotacoes.vue';
import GrupoCompraCadastroCotacao
  from '@/modules/compra-conjunta/cotacoes/GrupoCompraCadastroCotacao.vue';
import GrupoCompraCotacaoVisualizacao
  from '@/modules/compra-conjunta/cotacoes/visualizacao/GrupoCompraCotacaoVisualizacao.vue';
import GrupoCompraCotacaoRespostaDetail
  from '@/modules/compra-conjunta/cotacoes/visualizacao/analise/GrupoCompraCotacaoRespostaDetail.vue';
import GrupoCompraFechamentoCotacao
  from '@/modules/compra-conjunta/cotacoes/fechamento/GrupoCompraFechamentoCotacao.vue';

export default [
  {
    path: 'grupos-compra',
    name: 'main.compra-conjunta.grupos',
    components: {
      default: GruposCompra,
    },
  },
  {
    path: 'grupos-compra/:id',
    name: 'main.compra-conjunta.grupos.detalhes',
    components: {
      default: GrupoCompraCotacoes,
    },
  },
  {
    path: 'grupos-compra/:id/cadastro',
    name: 'main.compra-conjunta.grupos.cadastro',
    components: {
      default: GrupoCompraCadastroCotacao,
    },
  },
  {
    path: 'grupos-compra/:id/cotacao/:idCotacao',
    name: 'main.compra-conjunta.grupos.cotacao',
    components: {
      default: GrupoCompraCotacaoVisualizacao,
    },
  },
  {
    path: 'grupos-compra/:id/cotacao/:idCotacao/resposta/:idResposta',
    name: 'main.compra-conjunta.grupos.cotacao.resposta',
    components: {
      default: GrupoCompraCotacaoRespostaDetail,
    },
  },
  {
    path: 'grupos-compra/:id/cotacao/:idCotacao/resposta/:idResposta/fechamento/:idComprador',
    name: 'main.compra-conjunta.grupos.cotacao.resposta.fechamento',
    components: {
      default: GrupoCompraFechamentoCotacao,
    },
  },
];
